import React from 'react';
import CircularLoader from '../../common/CircularLoader';
import TrailQuestion from '../../questions/TrailQuestion';
import TrailWalkthrough from "../../questions/TrailWalkthrough";

const QuestionActivity = (props) => {
    const { step, stepActivity } = props;

    if (!step || !stepActivity) {
        return <CircularLoader />;
    }

    if (stepActivity.questionType === 'WALKTHROUGH') {
        return (
            <section className="ch-trail-question-activity">
                <TrailWalkthrough {...props} />
            </section>
        );
    }

    return (
        <section className="ch-trail-question-activity">
            <TrailQuestion {...props} />
        </section>
    );
};

export default QuestionActivity;